import { render, staticRenderFns } from "./UpgradeTierModal.vue?vue&type=template&id=faadd8da&scoped=true&"
import script from "./UpgradeTierModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeTierModal.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeTierModal.vue?vue&type=style&index=0&id=faadd8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faadd8da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faadd8da')) {
      api.createRecord('faadd8da', component.options)
    } else {
      api.reload('faadd8da', component.options)
    }
    module.hot.accept("./UpgradeTierModal.vue?vue&type=template&id=faadd8da&scoped=true&", function () {
      api.rerender('faadd8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/UpgradeTierModal.vue"
export default component.exports